import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X, CheckCircle2 } from "lucide-react";
import PostForm from "../components/posts/PostForm";

const NewPostPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const closeTimer = useRef(null);

  const handleClose = () => navigate(-1);

  const handleSuccess = () => {
    setShowSnackbar(true);
    closeTimer.current = setTimeout(() => {
      navigate("/feed");
    }, 2000);
  };

  useEffect(() => {
    return () => {
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-start justify-center overflow-y-auto bg-[#102E46]/65 px-3 py-5 backdrop-blur-[3px] sm:px-6 sm:py-12"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <div
        className="relative w-full max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-label={t("post.new_title")}
      >
        <div className="flex items-center justify-between border-b border-slate-100 bg-gradient-to-r from-[#F0F8FF] to-white px-5 py-5 sm:px-8">
          <h1 className="text-xl font-bold text-[#245580] sm:text-2xl">
            {t("post.form.placeholder", "À quoi penses-tu ?")}
          </h1>

          <button
            type="button"
            onClick={handleClose}
            aria-label={t("common.close")}
            className="ml-3 flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#247BA8]"
          >
            <X size={22} />
          </button>
        </div>

        <div className="px-4 py-5 sm:px-8 sm:py-7">
          <PostForm onSuccess={handleSuccess} />
        </div>
      </div>

      {showSnackbar && (
        <div
          role="status"
          aria-live="polite"
          className="fixed left-1/2 top-4 z-[10001] flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-center gap-3 rounded-2xl bg-[#245580] px-5 py-4 text-sm font-semibold text-white shadow-xl"
        >
          <CheckCircle2 size={22} className="shrink-0 text-green-300" />
          <span>{t("post.success_message")}</span>
        </div>
      )}
    </div>
  );
};

export default NewPostPage;
